import React from 'react';
import { Responsive, useResponsive } from '~/lib/useResponsive';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { CAROUSEL } from '../itemIds';
import { CarouselProvider, CarouselVariants } from './CarouselStore';
import { CarouselComponent } from './components/CarouselComponent';

interface Props {
  variant?: Responsive<CarouselVariants>;
  header?: { title: string; subtitle: string; icon: string };
  clearQuizFeedbackOnChange?: boolean;
  cssStylesForItem?: any;
  showProgressBar?: boolean;
  itemType?: 'QUESTION' | 'CARD';
}

export type CarouselDefinition = ItemDefinition<typeof CAROUSEL, Props>;

export class Carousel extends Item<typeof CAROUSEL, Props> {
  protected render({
    variant,
    children,
    id,
    header,
    clearQuizFeedbackOnChange,
    cssStylesForItem,
    showProgressBar,
    itemType = 'CARD'
  }: RenderProps<Props>) {
    const v = useResponsive(variant) || 'horizontal';

    return (
      <CarouselProvider>
        <CarouselComponent
          variant={v}
          showProgressBar={showProgressBar}
          id={id}
          header={header}
          clearQuizFeedbackOnChange={clearQuizFeedbackOnChange}
          cssStylesForItem={cssStylesForItem}
          itemType={itemType}
        >
          {children}
        </CarouselComponent>
      </CarouselProvider>
    );
  }
}

registry[CAROUSEL] = Carousel;
